import { Entity, FieldType, FileStorageType, PersistenceType } from 'gossamer-unified';
import { Event } from './Event';
import { Institution } from './Institution';
import { UserView } from './UserView';

export interface EventAuditRow {
  id: number;
  event_id: number;
  institution_id: number;
  change_type: string;
  performed_by: string;
  performed_at: string;
}

export const EventAudit: Entity<EventAuditRow> = {
  id: 'EventAudit',
  title: 'Event Audit',
  service: 'main',
  rowLabel: (row: EventAuditRow) => row.change_type,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.event_audit',
  },
  security: [
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: 'institution_id = {adminInstitutionId}',
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['performed_at', 'DESC']],
  defaultFilters: [],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      autoIncrement: true,
      persistence: PersistenceType.BackEndManaged,
    },
    event_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Event',
      refEntity: Event,
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    institution_id: {
      seq: 15,
      type: FieldType.Reference,
      label: 'Institution',
      refEntity: Institution,
      persistence: PersistenceType.BackEndManaged,
    },
    change_type: {
      seq: 20,
      label: 'Change Type',
      type: FieldType.Options,
      listColumn: true,
      options: [
        { id: 'create', label: 'create' },
        { id: 'cancel', label: 'cancel' },
        { id: 'delete', label: 'delete' },
        { id: 'change_host', label: 'changed host' },
        { id: 'change_location', label: 'changed location' },
        { id: 'reschedule', label: 'reschedule' },
        { id: 'update', label: 'update' },
      ],
      persistence: PersistenceType.BackEndManaged,
    },
    performed_by: {
      seq: 25,
      label: 'Performed By',
      type: FieldType.Reference,
      listColumn: true,
      refEntity: UserView,
      persistence: PersistenceType.BackEndManaged,
    },
    performed_at: {
      seq: 25,
      label: 'Performed At',
      type: FieldType.Datetime,
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
